<template>
  <div class="trial-lockout-overlay" :style="overlayStyle">
    <div class="trial-lockout-modal" role="dialog" aria-labelledby="canceled-lockout-title">
      <div class="trial-lockout-icon" aria-hidden="true">
        <svg fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
          <rect x="3" y="11" width="18" height="11" rx="2" />
          <path d="M7 11V7a5 5 0 0110 0v4" />
        </svg>
      </div>
      <h2 id="canceled-lockout-title" class="trial-lockout-title">{{ copy.title }}</h2>
      <p class="trial-lockout-sub" v-html="copy.messageHtml"></p>

      <p class="trial-lockout-foot">
        <a href="mailto:support@sentrykit.com?subject=SentryKit%20subscription%20reactivation">Contact support</a>
        ·
        <button type="button" @click="signOut">Log out</button>
      </p>
    </div>
  </div>
</template>

<script>
import './styles/TrialLockout.css'
import { canceledLockoutCopyFromSummary } from '../../utils/subscriptionBilling'

export default {
  name: 'CanceledLockoutOverlay',
  props: {
    stripOffsetPx: {
      type: Number,
      default: 0
    }
  },
  computed: {
    overlayStyle: function () {
      return { top: this.stripOffsetPx + 'px' }
    },
    copy: function () {
      return canceledLockoutCopyFromSummary(this.$root.subscriptionSummary)
    }
  },
  methods: {
    signOut: function () {
      if (this.$root.signOutUser) {
        this.$root.signOutUser()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CanceledLockoutOverlay.vue?43512b01